import React from 'react';
interface RatingBadgeProps {
  score: number;
  size?: 'small' | 'medium' | 'large';
}
export function RatingBadge({
  score,
  size = 'medium'
}: RatingBadgeProps) {
  const sizeClasses = {
    small: 'w-16 h-16 text-lg',
    medium: 'w-20 h-20 text-xl',
    large: 'w-24 h-24 text-2xl'
  };
  return <div className={`${sizeClasses[size]} rounded-full bg-green-500 flex items-center justify-center text-white font-bold shadow-lg`} data-id="element-75">
      {score}
    </div>;
}